import { call, cancelled, put } from 'redux-saga/effects';
import { api } from 'api';
import { EffectR } from 'types/utils';
import { FETCH_REGIONS_AND_STORES } from './actions';
import { fetchStoresAndRegions } from './api';

export function* doFetchRegionsAndStores() {
  const abortController = (yield call([api, 'abortController'])) as EffectR.Call<
    (typeof api)['abortController']
  >;
  try {
    yield put(FETCH_REGIONS_AND_STORES.request());
    const regionsAndStores = (yield call(fetchStoresAndRegions)) as EffectR.Call<
      typeof fetchStoresAndRegions
    >;
    yield put(FETCH_REGIONS_AND_STORES.success(regionsAndStores));
  } catch (err) {
    if (err instanceof Error) {
      yield put(FETCH_REGIONS_AND_STORES.failure(err));
    }
  } finally {
    if ((yield cancelled()) as boolean) {
      abortController.cancel();
      yield put(FETCH_REGIONS_AND_STORES.cancel());
    }
  }
}

export function* businessUnits() {
  yield call(doFetchRegionsAndStores);
}
